'use client';

import { useState } from 'react';
import { Button } from '@/components/atoms';
import { WithdrawPlayerModal } from '@/components/molecules/modals/WithdrawPlayerModal';
import dayjs from 'dayjs';
import { env } from '@env';
import { useOrganizationStore } from '@/store/organization-store';
import Link from 'next/link';
import clsx from 'clsx';

interface DetailsRegistrationButtonProps {
	isRegistrationOpen?: boolean | null;
	registrationEndDate?: Date | null;
	isUserPartOfLeague?: boolean | null;
	className?: string;
	useRegularStyling?: boolean;
}

export const DetailsRegistrationButton = ({
	isRegistrationOpen,
	registrationEndDate,
	isUserPartOfLeague,
	className,
	useRegularStyling
}: DetailsRegistrationButtonProps) => {
	const organizationStore = useOrganizationStore();
	const [showModal, setShowModal] = useState(false);

	const handleRegistrationModal = () => {
		setShowModal((prev) => !prev);
	};

	return (
		<>
			{showModal && <WithdrawPlayerModal onClose={handleRegistrationModal} />}

			<div className={`flex flex-col items-center ${className ?? ''}`}>
				{isRegistrationOpen && !isUserPartOfLeague ? (
					<div className="w-full">
						<Link
							href={`${env.NEXT_PUBLIC_TEAM_LEAGUES_CHECKOUT}/team-league/${organizationStore.organizationUuid}/${organizationStore.teamLeagueUuid}`}
						>
							<Button className="w-full px-[26px] py-3 text-base font-semibold leading-6 bg-orange-500 hover:bg-orange-700 text-white">
								Register now
							</Button>
						</Link>
						{registrationEndDate && (
							<p className="hidden text-[10px] pt-2 items-start text-left max-w-[150px]">
								Registration ends {dayjs(registrationEndDate).format('MMM D, YYYY h:mm a')}
							</p>
						)}
					</div>
				) : (
					<>
						{isUserPartOfLeague ? (
							<>
								<Button
									onClick={handleRegistrationModal}
									className={clsx(
										'w-full bg-orange-500 hover:bg-orange-700 text-white font-semibold leading-6 lg:py-1',
										!useRegularStyling ? 'text-xs  md:py-4 md:px-2 py-1 px-[10px] h-6 rounded-md' : ''
									)}
								>
									Withdraw
								</Button>
							</>
						) : null}
					</>
				)}
			</div>
		</>
	);
};
